import React, { useMemo } from 'react';
import { startOfMonth, endOfMonth, addDays, isSameMonth, isSameDay, format } from 'date-fns';
import { weekDays, layoutWeekBars, dayKey } from './calendarUtils';
import { EventBar } from './EventBar';

const MAX_LANES = 3;
const HEAD = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const WeekRow = ({ days, events, cursor, testId, onMore }) => {
  const bars = useMemo(() => layoutWeekBars(events, days), [events, days]);
  const visible = bars.filter((b) => b.lane < MAX_LANES);
  const hiddenPerCol = Array(7).fill(0);
  bars.filter((b) => b.lane >= MAX_LANES).forEach((b) => {
    for (let c = b.startCol; c < b.startCol + b.span; c++) hiddenPerCol[c] += 1;
  });
  return (
    <div className="relative grid grid-cols-7 border-b last:border-b-0" style={{ minHeight: 112 }}>
      {days.map((d, i) => {
        const today = isSameDay(d, new Date());
        return (
          <div key={i} className={`border-r last:border-r-0 p-1.5 flex flex-col ${isSameMonth(d, cursor) ? 'bg-background' : 'bg-muted/30'}`}
            data-testid={`${testId}-day-${dayKey(d)}`}>
            <span className={`text-xs font-medium w-6 h-6 flex items-center justify-center rounded-full
              ${today ? 'bg-lime text-lime-foreground' : isSameMonth(d, cursor) ? 'text-foreground' : 'text-muted-foreground'}`}>
              {format(d, 'd')}
            </span>
            {hiddenPerCol[i] > 0 && (
              <button type="button" onClick={() => onMore(d)} className="mt-auto text-[10px] text-left whitespace-nowrap text-muted-foreground hover:text-foreground hover:underline px-1"
                data-testid={`${testId}-more-${dayKey(d)}`}>
                +{hiddenPerCol[i]} more
              </button>
            )}
          </div>
        );
      })}
      <div className="absolute inset-x-0 top-8 grid grid-cols-7 gap-y-[3px] pointer-events-none [&>*]:pointer-events-auto" style={{ gridAutoRows: '18px' }}>
        {visible.map((b) => <EventBar key={`${b.event.id}-${b.startCol}`} bar={b} testId={testId} />)}
      </div>
    </div>
  );
};

export const MonthView = ({ cursor, events, testId, onMore }) => {
  const weeks = useMemo(() => {
    const out = [];
    let d = weekDays(startOfMonth(cursor))[0];
    const end = endOfMonth(cursor);
    while (d <= end) { out.push(weekDays(d)); d = addDays(d, 7); }
    return out;
  }, [cursor]);
  return (
    <div className="border rounded-lg overflow-hidden" data-testid={`${testId}-month`}>
      <div className="grid grid-cols-7 border-b bg-muted/40">
        {HEAD.map((h) => <div key={h} className="py-2 text-center text-xs font-semibold text-muted-foreground uppercase tracking-wide">{h}</div>)}
      </div>
      {weeks.map((days) => (
        <WeekRow key={dayKey(days[0])} days={days} events={events} cursor={cursor} testId={testId} onMore={onMore} />
      ))}
    </div>
  );
};
